const Resources = {

    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "<span class='slash'>/</span>",
        },
    ],

    rooms_table_headers: [
        {
            text:   'Building',
            value:  'building_name',
            report_value: 'building_name',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Level',
            value:  'level_name',
            report_value: 'level_name',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Area',
            value:  'area_name',
            report_value: 'area_name',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Room Type',
            value:  'room_type_name',
            report_value: 'room_type_name',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Floor Type',
            value:  'floor_name',
            report_value: 'floor_name',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Cost Center',
            value:  'cost_center_name',
            report_value: 'cost_center_name',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Door Number',
            value:  'door_number',
            report_value: 'door_number',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Walking#',
            value:  'walking_number',
            report_value: 'walking_number',
            type:   '',
            show: true,
            order: 0,

        },
        { 
            text:   'Description',
            value:  'sort_desc',
            report_value: 'sort_desc',
            type:   '',
            with_icon: true,
            show: true,
            order: 1,
        },
        { 
            text:   'Fixture/Beds',
            value:  'fixture_number',
            report_value: 'fixture_number',
            show: true,
            order: 2,
        },
        { 
            text:   'Minutes',
            value:  'daily_tasks_minutes',
            report_value: 'daily_tasks_minutes',
            show: true,
            order: 2,
        },
        { 
            text:   'Sq.Feet',
            value:  'sq_ft',
            report_value: 'sq_ft',
            show: true,
            order: 3,
        },
        {
            text:   'Patient',
            value:  'formatted_patient',
            report_value: 'formatted_patient',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Work Group 2',
            value:  'formatted_work_group',
            report_value: 'formatted_work_group',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Exclude Daily',
            value:  'formatted_exclude_daily',
            report_value: 'formatted_exclude_daily',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Exclude Project',
            value:  'formatted_exclude_project',
            report_value: 'formatted_exclude_project',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Essential Cleaning',
            value:  'formatted_essential_cleaning',
            report_value: 'formatted_essential_cleaning',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Closed',
            value:  'formatted_closed',
            report_value: 'formatted_closed',
            type:   '',
            show: true,
            order: 0,

        },
        {   
            text:   'Associated Assignment',
            value:  'associated_assignments',
            type: '',
            report_value: 'associated_assignments',
            show: true,
            order: 4,
        },
        {   
            text:   'DailyTask(s)',
            value:  'daily_tasks',
            type: 'tasks',
            report_value: 'daily_tasks',
            show: true,
            order: 4,
        },
        {   
            text:   'PolicingTask(s)',
            value:  'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
            report_value: 'policing_tasks',
            show: true,
            order: 5,
        },
        {   
            text:   'ProjectTask(s)',
            value:  'project_tasks',
            report_value: 'project_tasks',
            type:   'tasks',
            class:  'header-orange',
            show: true,
            order: 6,
        },
    ],

    room_tasks_table_headers: [
        {
            text:   'Walking #',
            value:  'walking_number',
            report_value: 'walking_number',
            style: "width: 8%;",
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Room',
            value:  'custom_description',
            report_value: 'custom_description',
            type:   '',
            show: true,
            order: 0,
            style: "width: 30%;"
        },
        {
            text:   'Task',
            value:  'task',
            report_value: 'task',
            type:   '',
            show: true,
            order: 0,
            style: "width: 10%;"
        },
        {
            text:   'Daily Min',
            value:  'daily_minutes',
            report_value: 'daily_minutes',
            type:   '',
            show: true,
            order: 0,
            style: "width: 6%;"
        },
        {
            text:   'Annual Min',
            value:  'annual_minutes',
            report_value: 'annual_minutes',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%;"
        },
        {
            text:   'Frequency',
            value:  'frequency',
            report_value: 'frequency',
            type:   '',
            show: true,
            order: 0,
            style: "width: 10%;"
        },
        {
            text:   'SQ Ft',
            value:  'sq_ft',
            report_value: 'sq_ft',
            type:   '',
            show: true,
            order: 0,
            style: "width: 5%;"
        },
        {
            text:   'Group',
            value:  'work_group',
            report_value: 'work_group',
            type:   '',
            show: true,
            order: 0,
            style: "width: 10%;"
        },
        {
            text:   'Last Completed',
            value:  'latest_last_completed',
            report_value: 'latest_last_completed',
            type:   '',
            show: true,
            order: 0,
            style: "width: 13%;"
        },
        {
            text:   'Associated Assignments',
            value:  'associated_assignments',
            report_value: 'associated_assignments',
            type:   '',
            show: true,
            order: 0,
            style: "width: 13%;"
        },
        {
            text:   'Building',
            value:  'building_name',
            report_value: 'building_name',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Level',
            value:  'level_name',
            report_value: 'level_name',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Area',
            value:  'area_name',
            report_value: 'area_name',
            type:   '',
            show: true,
            order: 0,

        },
        {
            text:   'Room Type',
            value:  'room_type_name',
            report_value: 'room_type_name',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Floor Type',
            value:  'floor_name',
            report_value: 'floor_name',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Cost Center',
            value:  'cost_center_name',
            report_value: 'cost_center_name',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Door Number',
            value:  'door_number',
            report_value: 'door_number',
            type:   '',
            show: true,
            order: 0,
        },
        { 
            text:   'Fixture/Beds',
            value:  'fixtures_number',
            report_value: 'fixtures_number',
            show: true,
            order: 2,
        },
        { 
            text:   'Sq.Feet',
            value:  'sq_ft',
            report_value: 'sq_ft',
            show: true,
            order: 3,
        },
        {
            text:   'Patient',
            value:  'formatted_patient',
            report_value: 'formatted_patient',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Work Group 2',
            value:  'formatted_work_group',
            report_value: 'formatted_work_group',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Exclude Daily',
            value:  'formatted_exclude_daily',
            report_value: 'formatted_exclude_daily',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Exclude Project',
            value:  'formatted_exclude_project',
            report_value: 'formatted_exclude_project',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Essential Cleaning',
            value:  'formatted_essential_cleaning',
            report_value: 'formatted_essential_cleaning',
            type:   '',
            show: true,
            order: 0,
        },
        {
            text:   'Closed',
            value:  'formatted_closed',
            report_value: 'formatted_closed',
            type:   '',
            show: true,
            order: 0,

        }
    ],

    buildings_table_headers: [
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            report_value: 'name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Abbreviation',
            value: 'abbreviation',
            report_value: 'abbreviation',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Level Counter',
            value: 'level_counter',
            report_value: 'total_levels',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Area Counter',
            value: 'area_counter',
            report_value: 'total_areas',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Room Counter',
            value: 'room_counter',
            report_value: 'total_rooms',
            type: 'text_link_action',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Sq. Footage',
            value: 'sq_footage',
            report_value: 'total_sq_ft',
            sort_type: 'number',
            show: true,
        },
    ],

    levels_table_headers: [
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            report_value: 'name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Abbreviation',
            value: 'abbreviation',
            report_value: 'abbreviation',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Building',
            value: 'building',
            report_value: 'building_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Area Counter',
            value: 'area_counter',
            report_value: 'total_areas',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Room Counter',
            value: 'room_counter',
            report_value: 'total_rooms',
            type: 'text_link_action',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Sq. Footage',
            value: 'sq_ft',
            report_value: 'total_sq_ft',
            sort_type: 'number',
            show: true,
        },
    ],

    areas_table_headers: [
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            report_value: 'name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Abbreviation',
            value: 'abbreviation',
            report_value: 'abbreviation',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Building',
            value: 'building_name',
            report_value: 'building_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Level',
            value: 'level_name',
            report_value: 'level_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Frequency',
            value: 'frequency',
            report_value: 'frequency',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Room Counter',
            value: 'total_rooms',
            report_value: 'total_rooms',
            type: 'text_link_action',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Sq. Footage',
            value: 'total_sq_ft',
            report_value: 'total_sq_ft',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Daily Shift 1',
            value: 'daily_shift_1',
            report_value: 'daily_shift_1',
            sort_type: 'number',
            type: 'boolean',
            show: true,
        },
        {
            text: 'Daily Shift 2',
            value: 'daily_shift_2',
            report_value: 'daily_shift_2',
            type: 'boolean',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Daily Shift 3',
            value: 'daily_shift_3',
            report_value: 'daily_shift_3',
            type: 'boolean',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Policing Shift 1',
            value: 'policing_shift_1',
            report_value: 'policing_shift_1',
            type: 'boolean',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Policing Shift 2',
            value: 'policing_shift_2',
            report_value: 'policing_shift_2',
            type: 'boolean',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Policing Shift 3',
            value: 'policing_shift_3',
            report_value: 'policing_shift_3',
            type: 'boolean',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Project Shift 1',
            value: 'project_shift_1',
            report_value: 'project_shift_1',
            type: 'boolean',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Project Shift 2',
            value: 'project_shift_2',
            report_value: 'project_shift_2',
            type: 'boolean',
            sort_type: 'number',
            show: true,
        },
        {
            text: 'Project Shift 3',
            value: 'project_shift_3',
            report_value: 'project_shift_3',
            type: 'boolean',
            sort_type: 'number',
            show: true,
        },
    ],

    cost_centers_table_headers: [
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            report_value: 'name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Cost Center #',
            value: 'cost_center',
            report_value: 'cost_center',
            sort_type: 'text',
            show: true,
        },
        {
            text: "Director's First Name",
            value: 'director_first_name',
            report_value: 'director_first_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: "Director's Last Name",
            value: 'director_last_name',
            report_value: 'director_last_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: "Director's Ext",
            value: 'director_ext',
            report_value: 'director_ext',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Room Counter',
            value: 'total_rooms',
            report_value: 'total_rooms',
            type: 'text_link_action',
            sort_type: 'number',
            show: true,
        },
    ],

    cost_center_departments_table_headers: [
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            report_value: 'name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Cost Center',
            value: 'cost_center_name',
            report_value: 'cost_center_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Personnel Counter',
            value: 'total_personnel',
            report_value: 'total_personnel',
            type: 'text_link_action',
            sort_type: 'number',
            show: true,
        },
        {
            text: "Associate's Counter",
            value: 'total_associates',
            report_value: 'total_associates',
            type: 'text_link_action',
            sort_type: 'number',
            show: true,
        },
    ],

    cost_center_personnel_table_headers: [
        {
            text: 'First Name',
            align: 'start',
            value: 'name',
            report_value: 'name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Last Name',
            value: 'last_name',
            report_value: 'last_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: "Email",
            value: 'email',
            report_value: 'email',
            sort_type: 'text',
            show: true,
        },
        {
            text: "Cost Center Name",
            value: 'cost_center_name',
            report_value: 'cost_center_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: "Department Name",
            value: 'cost_center_department_name',
            report_value: 'cost_center_department_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: "Ext",
            value: 'ext',
            report_value: 'ext',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Manager',
            value: 'is_manager',
            report_value: 'is_manager',
            type: 'boolean',
            sort_type: 'text',
            show: true,
        },
    ],

    room_types_table_headers: [
        {
            text: 'Name',
            align: 'start',
            value: 'description',
            report_value: 'description',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Abbreviation',
            align: 'start',
            value: 'abbreviation',
            report_value: 'abbreviation',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Floor',
            value: 'floor_name',
            report_value: 'floor_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Housekeeper II',
            value: 'housekeeper',
            report_value: 'housekeeper',
            type: 'boolean',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Patient',
            value: 'patient',
            report_value: 'patient',
            type: 'boolean',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Unit',
            value: 'unit',
            report_value: 'unit',
            type: '',
            sort_type: 'text',
            show: true,
        },
        {
            text: "Room Counter",
            value: 'total_rooms',
            report_value: 'total_rooms',
            type: 'text_link_action',
            sort_type: 'number',
            show: true,
        },
        {   
            text:   'Daily Task(s)',
            value:  'daily_tasks',
            report_value: 'daily_tasks',
            type:   'text_bold',
            show: true,
        },
        {   
            text:   'Policing Task(s)',
            value:  'policing_tasks',
            report_value: 'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
            show: true,
        },
        {   
            text:   'Project Task(s)',
            value:  'project_tasks',
            report_value: 'project_tasks',
            type:   'tasks',
            class:  'header-orange',
            show: true,
        },
    ],

    associates_table_headers: [
        { 
            text:           'Facilities Granted Access',
            align:          'start',
            value:          'facility_names',
            report_value:   'facility_names',
            show:           true,
        },
        { 
            text:           'Name',
            align:          'start',
            value:          'associate_name',
            report_value:   'associate_name',
            show:           true,
        },
        {
            text:           'Email',
            value:          'email',
            report_value:   'email',
            show:           true,
        },
        {
            text:           'Phone 1',
            value:          'phone1',
            report_value:   'phone1',
            show:           true,
        },
        {
            text:           'Phone 2',
            value:          'phone2',
            report_value:   'phone2',
            show:           true,
        },
        {
            text:           'Emergency Phone',
            value:          'emergency_phone',
            report_value:   'emergency_phone',
            show:           true,
        },
        {
            text:           'Country',
            value:          'country',
            report_value:   'country',
            show:           true,
        },
        {
            text:           'State',
            value:          'state',
            report_value:   'state',
            show:           true,
        },
        {
            text:           'City',
            value:          'city',
            report_value:   'city',
            show:           true,
        },
        {
            text:           'Zip code',
            value:          'zip_code',
            report_value:   'zip_code',
            type:           '',
            show:           true,
        },
        {
            text:           'Address 1',
            value:          'address1',
            report_value:   'address1',
            show:           true,
        },
        {
            text:           'Address 2',
            value:          'address2',
            report_value:   'address2',
            show:           true,
        },
        {
            text:           'Pager Number',
            value:          'pager_number',
            report_value:   'pager_number',
            show:           true,
        },
        {
            text:           'Include in Supervisor Lists',
            value:          'include_in_supervisor_lists',
            report_value:   'include_in_supervisor_lists',
            type:           'boolean',
            show:           true,
        },
        {
            text:           'Reports to',
            value:          'reports_to',
            report_value:   'reports_to',
            show:           true,
        },
        {
            text:           'Role',
            value:          'role',
            report_value:   'role',
            type:           'role',
            show:           true,
        },
        {
            text:           'Permissions Template',
            value:          'permissions_template_name',
            report_value:   'permissions_template_name',
            type:           '',
            show:           true,
        },
        {
            text:           'Is Active',
            value:          'status',
            report_value:   'status',
            type:           'boolean',
            show:           true,
        },
        {
            text:           'Position',
            value:          'position_name',
            report_value:   'position_name',
            type:           '',
            show:           true,
        },
        {
            text:           'Contact Type',
            value:          'contract_type_description',
            report_value:   'contract_type_description',
            type:           '',
            show:           true,
        },
        {
            text:           'Cost Center Department',
            value:          'cost_center_department_name',
            report_value:   'cost_center_department_name',
            type:           '',
            show:           true,
        },
        {
            text:           'Shift',
            value:          'shift_name',
            report_value:   'shift_name',
            type:           '',
            show:           true,
        },
        {
            text:           'Birth Date',
            value:          'formatted_birth_date',
            report_value:   'formatted_birth_date',
            show:           true,
        },
        {
            text:           'Hours',
            value:          'hours',
            report_value:   'hours',
            show:           true,
        },
        {
            text:           'Hourly Pay',
            value:          'hourly_pay',
            report_value:   'hourly_pay',
            show:           true,
        },
        {
            text:           'Hire Date',
            value:          'formatted_hire_date',
            report_value:   'formatted_hire_date',
            show:           true,
        },
        {
            text:           'Department Date of Hire',
            value:          'formatted_department_hire_date',
            report_value:   'formatted_department_hire_date',
            show:           true,
        },
        {
            text:           'Next Evaluation',
            value:          'formatted_next_evaluation',
            report_value:   'formatted_next_evaluation',
            show:           true,
        },
        { 
            text:           'Associate ID',
            value:          'associate_number',
            report_value:   'associate_number',
            show:           true,
        },
        { 
            text:           'Comments',
            value:          'comments',
            report_value:   'comments',
            show:           true,
        },
    ],

    positions_table_headers: [
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            report_value: 'name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Description',
            value: 'description',
            report_value: 'description',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Group',
            value: 'group_name',
            report_value: 'group_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: "Start Salary",
            value: 'start_salary',
            report_value: 'start_salary',
            sort_type: 'text',
            show: true,
        },
        {
            text: "End Salary",
            value: 'end_salary',
            report_value: 'end_salary',
            sort_type: 'text',
            show: true,
        },
    ],

    contact_types_table_headers: [
        {
            text: 'Description',
            align: 'start',
            value: 'description',
            report_value: 'description',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Include Days Off',
            value: 'include_days_off',
            report_value: 'include_days_off',
            type: 'boolean',
            show: true,
        },
        {
            text: 'Include Assignment',
            value: 'include_assignment',
            report_value: 'include_assignment',
            type: 'boolean',
            show: true,
        },
        {
            text: 'Include Census',
            value: 'include_census',
            report_value: 'include_census',
            type: 'boolean',
            show: true,
        },
        {
            text: 'Include QC',
            value: 'include_qc',
            report_value: 'include_qc',
            type: 'boolean',
            show: true,
        },
        {
            text: 'Associate Counter',
            value: 'total_associates',
            report_value: 'total_associates',
            sort_type: 'text',
            show: true,
        },
        
    ],

    daily_assignments_table_headers: [
        { 
            text:   'Assignment #',
            value:  'number_assigment',
            report_value: 'number_assigment',
            show: true
        },
        { 
            text:   'Description',
            align:  'start',
            value:  'description',
            report_value:  'description',
            show: true
        },
        { 
            text: 'Days/Week',   
            value: 'days_per_week',
            report_value: 'days_per_week',
            show: true
        },
        { 
            text: 'Minutes/Discharge',   
            value: 'minutes',
            report_value: 'minutes',
            show: true
        },
        {   
            text: 'Avg. Time',
            value: 'avg_time_day',
            report_value: 'avg_time_day',
            show: true
        },
        {   
            text: 'Total Time',
            value: 'total_minutes',
            report_value: 'total_minutes',
            show: true
        },
        {
            text: 'Avalaible Minutes',
            value: 'total_shift_work_time',
            report_value: 'total_shift_work_time',
            show: true
        },
        {
            text: 'Sq ft',
            value: 'total_sq_ft',
            report_value: 'total_sq_ft',
            show: true
        },
        {   
            text: 'Census',
            value: 'census',
            report_value: 'census',
            type: 'boolean',
            show: true
        },
        { 
            text: 'Shift',
            value: 'shift',
            report_value: 'shift',
            show: true
        },
        { 
            text: 'Group',
            value: 'group_name',
            report_value: 'group_name',
            show: true
        },
        { 
            text: 'Cost Center Department',
            value: 'cost_center_department_name',
            report_value: 'cost_center_department_name',
            show: true
        },
        { 
            text: 'Associate',
            value: 'associate',
            report_value: 'associate',
            show: true
        },
        { 
            text:   'Associate Pager',
            value:  'associate_pager',
            report_value:  'associate_pager',
            show: true
        },
        { 
            text: 'Supervisor',
            value: 'supervisor',
            report_value: 'supervisor',
            show: true
        },
        { 
            text: 'Supervisor Pager',
            value: 'supervisor_pager',
            report_value: 'supervisor_pager',
            show: true
        },
    ],

    shifts_table_headers: [
        { 
            text: 'Number #',
            align: 'start',
            value: 'number',
            report_value: 'number',
            show: true
        },
        { 
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true
        },
        { 
            text: 'Class',
            value: 'class_name',
            report_value: 'class_name',
            show: true
        },
        { 
            text: 'Prep. Minutes',
            value: 'prep_minutes',
            report_value: 'prep_minutes',
            show: true
        },
        { 
            text: 'Cleanup Minutes',
            value: 'clenaup_minutes',
            report_value: 'clenaup_minutes',
            show: true
        },
        { 
            text: 'Start time',
            value: 'start_time',
            report_value: 'start_time',
            show: true
        },
        {   
            text: 'End time',
            value: 'end_time',
            report_value: 'end_time',
            show: true
        },
        { 
            text: 'Total Hours',
            value: 'total_time',
            type:   'hours',
            report_value: 'total_time',
            show: true
        },
        { 
            text: 'Total minutes',
            value: 'total_shift_minutes',
            report_value: 'total_shift_minutes',
            show: true
        },
        { 
            text: 'Work Time',
            value: 'total_shift_work_time',
            report_value: 'total_shift_work_time',
            show: true
        },
        { 
            text: 'Breaks counter',
            value: 'total_breaks',
            report_value: 'total_breaks',
            show: true
        },
    ],

    breaks_table_headers: [
        { 
            text: 'Number #',
            align: 'start',
            value: 'number',
            report_value: 'number',
            show: true
        },
        { 
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true
        },
        { 
            text: 'Shift',
            value: 'shift_name',
            report_value: 'shift_name',
            show: true
        },
        { 
            text: 'Break Time',
            value: 'time',
            report_value: 'time',
            show: true
        },
        {   
            text: 'Length',
            value: 'length',
            report_value: 'length',
            show: true
        },
        { 
            text: 'Paid',
            value: 'paid',
            type:   'boolean',
            report_value: 'paid',
            show: true
        },
    ],

    tasks_table_headers: [
        { 
            text: 'Cleaning Code',
            align: 'start',
            value: 'name',
            report_value: 'name',
            show: true
        },
        { 
            text: 'Name',
            value: 'description',
            report_value: 'description',
            show: true
        },
        { 
            text: 'Task Type',
            value: 'task_type',
            report_value: 'task_type',
            show: true
        },
        { 
            text: 'Production Standard',
            value: 'production_standard',
            report_value: 'production_standard',
            show: true
        },
        { 
            text: 'Unit',
            value: 'unit',
            report_value: 'unit',
            show: true
        },
    ],

    projects_table_headers: [
        { 
            text: 'Number',
            align: 'start',
            value: 'number',
            report_value: 'number',
            show: true
        },
        { 
            text: 'Name',
            value: 'description',
            report_value: 'description',
            show: true
        },
        { 
            text: 'Associate',
            value: 'associate',
            report_value: 'associate',
            show: true
        },
        { 
            text: 'Notes',
            value: 'notes',
            report_value: 'notes',
            show: true
        },
        { 
            text: 'Total Minutes',
            value: 'total_minutes',
            report_value: 'total_minutes',
            show: true
        },
        { 
            text: 'Show Minutes',
            value: 'show_minutes',
            report_value: 'show_minutes',
            type: 'boolean',
            show: true
        },
    ],

    service_requests_table_headers: [
        { 
            text: 'Description',
            align: 'start',
            value: 'description',
            report_value: 'description',
            show: true
        },
        { 
            text: 'Room',
            value: 'room',
            report_value: 'room',
            show: true
        },
        { 
            text: 'Requestor Name',
            value: 'requestor_name',
            report_value: 'requestor_name',
            show: true
        },
        { 
            text: 'Requestor Email',
            value: 'requestor_email',
            report_value: 'requestor_email',
            show: true
        },
        { 
            text: 'Requestor Phone',
            value: 'requestor_phone',
            report_value: 'requestor_phone',
            show: true
        },
    ],

    staffing_scenarios_table_headers: [
        { 
            text: 'Scenario',
            align: 'start',
            value: 'scenario',
            report_value: 'scenario',
            show: true
        },
        { 
            text: 'FTE hours',
            value: 'fte_hours',
            report_value: 'fte_hours',
            show: true
        },
        { 
            text: 'Budgeted FTEs',
            value: 'budgeted_ftes',
            report_value: 'budgeted_ftes',
            show: true
        },
        { 
            text: 'Created On',
            value: 'created_on',
            report_value: 'created_on',
            show: true
        },
        { 
            text: 'Benefits',
            value: 'benefits',
            report_value: 'benefits',
            show: true
        },
        { 
            text: 'Nonproductive',
            value: 'nonproductive',
            report_value: 'nonproductive',
            show: true
        },
        { 
            text: 'Last Modified',
            value: 'updated_on',
            report_value: 'updated_on',
            show: true
        },
        { 
            text: 'Paid Break Minutes',
            value: 'paid_break_minutes',
            report_value: 'paid_break_minutes',
            show: true
        },
        { 
            text: 'Management Team',
            value: 'management_team',
            report_value: 'management_team',
            show: true
        },
        { 
            text: 'Average Wage',
            value: 'average_wage',
            report_value: 'average_wage',
            show: true
        },
        { 
            text: 'Total Salary Compensation',
            value: 'total_salary_compensation',
            report_value: 'total_salary_compensation',
            show: true
        },
    ],

    beds_table_headers: [
        { 
            text: 'Room',
            align: 'start',
            value: 'room',
            report_value: 'room',
            show: true
        },
        { 
            text: 'Bed',
            value: 'name',
            report_value: 'name',
            show: true
        }
    ],

    log_productivities_table_headers: [
        { 
            text: 'Daily Assignment',
            align: 'start',
            value: 'daily_assignment',
            report_value: 'daily_assignment',
            show: true
        },
        { 
            text: 'Associate:',
            value: 'associate',
            report_value: 'associate',
            show: true
        },
        { 
            text: 'Date:',
            value: 'date',
            report_value: 'date',
            show: true
        },
        { 
            text: 'Include In Productivity:',
            value: 'include_productivity',
            report_value: 'include_productivity',
            type: 'boolean',
            show: true
        }
    ],

    rotation_templates_table_headers: [
        { 
            text: 'Description',
            align: 'start',
            value: 'description',
            report_value: 'description',
            show: true
        },
        { 
            text: 'Day Rotations',
            value: 'day_rotations',
            report_value: 'day_rotations',
            show: true
        },
        { 
            text: 'Day of week rotation begins',
            value: 'schedule_day',
            report_value: 'schedule_day',
            show: true
        },
        { 
            text: 'Schedule Start Date',
            value: 'start_date',
            report_value: 'start_date',
            show: true
        },
        { 
            text: 'Shift',
            value: 'shift',
            report_value: 'shift',
            show: true
        },
        { 
            text: 'Template Counter',
            value: 'total_templates',
            report_value: 'total_templates',
            show: true
        },
        { 
            text: 'Schedule Counter',
            value: 'total_schedules',
            report_value: 'total_schedules',
            show: true
        },
        
    ],

    inspection_templates_table_headers: [
        { 
            text: 'Name',
            align: 'start',
            value: 'name',
            report_value: 'name',
            show: true
        },
        { 
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true
        },
        { 
            text: 'Instruction',
            value: 'instruction',
            report_value: 'instruction',
            show: true
        },
        { 
            text: 'Inspection Items Counter',
            value: 'total_items',
            report_value: 'total_items',
            show: true
        },
        { 
            text: 'Room Type Counter',
            value: 'total_room_types',
            report_value: 'total_room_types',
            show: true
        },
        { 
            text: 'Template Inspection Counter',
            value: 'total_template_inspections',
            report_value: 'total_template_inspections',
            show: true
        },
        { 
            text: 'Instant Inspection Counter',
            value: 'total_instant_inspections',
            report_value: 'total_instant_inspections',
            show: true
        },
        
    ],

    template_inspections_table_headers: [
        { 
            text: 'Title',
            align: 'start',
            value: 'title',
            report_value: 'title',
            show: true
        },
        { 
            text: 'Completed',
            value: 'status',
            report_value: 'status',
            type: 'boolean',
            show: true
        },
        { 
            text: 'Manager Comment',
            value: 'manager_comment',
            report_value: 'manager_comment',
            show: true
        },
        { 
            text: 'Date',
            value: 'date',
            report_value: 'date',
            show: true
        },
        { 
            text: 'Room Type',
            value: 'room_type_name',
            report_value: 'room_type_name',
            show: true
        },
        { 
            text: 'Associate(s)',
            value: 'all_associates',
            report_value: 'all_associates',
            show: true
        },
        { 
            text: 'Inspection Template',
            value: 'inspection_template_name',
            report_value: 'inspection_template_name',
            show: true
        },
        { 
            text: 'Supervisor',
            value: 'associate',
            report_value: 'associate',
            show: true
        },
        { 
            text: 'Score',
            value: 'score',
            report_value: 'score',
            show: true
        },
        { 
            text: 'Room Counter',
            value: 'total_rooms',
            report_value: 'total_rooms',
            show: true
        },
        
    ],

    instant_inspections_table_headers: [
        { 
            text: 'Title',
            align: 'start',
            value: 'title',
            report_value: 'title',
            show: true
        },
        { 
            text: 'Completed',
            value: 'status',
            report_value: 'status',
            type: 'boolean',
            show: true
        },
        { 
            text: 'Manager Comment',
            value: 'manager_comment',
            report_value: 'manager_comment',
            show: true
        },
        { 
            text: 'Date',
            value: 'date',
            report_value: 'date',
            show: true
        },
        { 
            text: 'Inspection Template',
            value: 'inspection_template_name',
            report_value: 'inspection_template_name',
            show: true
        },
        { 
            text: 'Supervisor',
            value: 'associate',
            report_value: 'associate',
            show: true
        },
        { 
            text: 'Associate(s)',
            value: 'all_associates',
            report_value: 'all_associates',
            show: true
        },
        { 
            text: 'Score',
            value: 'score',
            report_value: 'score',
            show: true
        },
        { 
            text: 'Room',
            value: 'room',
            report_value: 'room',
            show: true
        },
        
    ],

    inspection_items_table_headers: [
        { 
            text: 'Name',
            value: 'name',
            align: 'start',
            report_value: 'name',
            show: true
        },
        { 
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true
        },
        { 
            text: 'Associated Room Types',
            value: 'total_room_types',
            report_value: 'total_room_types',
            show: true
        },
        
    ],

    surveys_table_headers: [
        { 
            text: 'Name',
            value: 'name',
            align: 'start',
            report_value: 'name',
            show: true
        },
        { 
            text: 'Note',
            value: 'note',
            report_value: 'note',
            show: true
        },
        { 
            text: 'Subject',
            value: 'subject',
            report_value: 'subject',
            show: true
        },
        { 
            text: 'Email Body',
            value: 'email_body',
            report_value: 'email_body',
            show: true
        },
        { 
            text: 'Question Counter',
            value: 'total_questions',
            report_value: 'total_questions',
            show: true
        },
        
    ],

    step_codes_table_headers: [
        { 
            text: 'Name',
            value: 'name',
            align: 'start',
            report_value: 'name',
            show: true
        },
        { 
            text: 'Code',
            value: 'code',
            report_value: 'code',
            show: true
        },
        { 
            text: 'Memo',
            value: 'memo',
            report_value: 'memo',
            show: true
        },
    ],

    vacant_beds_adjustment_table_headers: [
        { 
            text: 'Room Usage',
            value: 'room_usage',
            align: 'start',
            report_value: 'room_usage',
            show: true
        },
        { 
            text: 'Vacant Bed Adjustment',
            value: 'vacant_bed',
            report_value: 'vacant_bed',
            show: true
        },
    ],

    floor_types_table_headers: [
        { 
            text: 'Name',
            value: 'name',
            align: 'start',
            report_value: 'name',
            show: true
        },
        { 
            text: 'Associated Tasks',
            value: 'total_tasks',
            report_value: 'total_tasks',
            show: true
        },
    ],

    time_off_table_headers: [
        { 
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true
        },
    ],

    

}

export default Resources;